import { useLazyQuery } from '@apollo/client';
import type { UseSegmentsLinkedAudiencesFetch } from '@openx/components-segment/lib/utils/context/SegmentHookTypes';
import { useCallback } from 'react';
import { GetSegmentsWithLinkedAudiencesDocument } from '../../../graphql/query/segments/GetSegmentsWithLinkedAudiences.generated';

export const useSegmentsLinkedAudiencesFetch: UseSegmentsLinkedAudiencesFetch = () => {
  const [getSegmentsLinkedAudiences] = useLazyQuery(GetSegmentsWithLinkedAudiencesDocument);

  const fetchSegmentsLinkedAudiences = useCallback(
    async (segmentIds: string[]) => {
      const { loading, data: { segments = [] } = {} } = await getSegmentsLinkedAudiences({
        fetchPolicy: 'network-only',
        variables: {
          segmentIds,
        },
      });

      return {
        loading,
        segments,
      };
    },
    [getSegmentsLinkedAudiences]
  );

  return {
    fetchSegmentsLinkedAudiences,
  };
};
